import React, { useState, useEffect } from 'react';
import './CorporateTravel.css';
import jaipurImage from '../assets/images/jaipur.jpg';

const CorporateTravel = ({ setEnquiryPackageData, setIsEnquiryOpen }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Destination images for slideshow
  const destinationImages = [
    '/images/destinations/jaipur.jpg',
    '/images/destinations/udaipur.jpg',
    '/images/destinations/jodhpur.jpg',
    '/images/destinations/jaisalmer.jpg',
    '/images/destinations/pushkar.jpg',
    '/images/destinations/ajmer.jpg',
    '/images/destinations/bikaner.jpg',
    '/images/destinations/chittorgarh.jpg',
    '/images/destinations/mount-abu.jpg',
    '/images/destinations/ranthambore.jpg'
  ];

  // Auto-advance slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % destinationImages.length
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [destinationImages.length]);

  const handleEnquiry = (serviceType, isDetailed = false) => {
    setEnquiryPackageData({
      title: `${serviceType}`,
      type: 'corporate-service',
      isDetailed: isDetailed
    });
    setIsEnquiryOpen(true);
  };

  return (
    <div className="corporate-travel-page">
      {/* Hero Section */}
      <section 
        className="corporate-hero"
        style={{
          '--mobile-bg-image': `url(${jaipurImage})`
        }}
      >
        {/* Video Background */}
        <div className="hero-video">
          <video 
            autoPlay 
            muted 
            loop 
            playsInline
            className="hero-video-element"
            preload="auto"
          >
            <source src="/videos/camel-video-2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        {/* Dark overlay for text readability */}
        <div className="hero-overlay"></div>
        
        <div className="corporate-hero-overlay">
          <div className="container">
            <div className="corporate-hero-content">
              <h1>Corporate & Educational Travel Solutions</h1>
              <p>Professional travel management services tailored for businesses, educational institutions, and group organizations</p>
              <div className="corporate-hero-stats">
                <div className="stat">
                  <span className="stat-number">10,000+</span>
                  <span className="stat-label">Successful Trips</span>
                </div>
                <div className="stat">
                  <span className="stat-number">30+</span>
                  <span className="stat-label">Years of Experience</span>
                </div>
              </div>
              <div className="hero-cta">
                <button 
                  className="btn-hero-secondary"
                  onClick={() => handleEnquiry('Travel Consultation', true)}
                >
                  Get Free Consultation
                </button>
                <a 
                  href="tel:+919876543210" 
                  className="btn-hero-secondary"
                >
                  <i className="fas fa-phone"></i> Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Logos Section */}
      <section className="customer-logos">
        <div className="container">
          <div className="section-header">
            <h2>Trusted by Leading Organizations</h2>
            <p>We are grateful to have served the following prestigious organizations and countless other customers over the years.</p>
          </div>
          <div className="logos-container">
            <div className="logos-scroll">
              <div className="logo-item">
                <img src="/images/customer/customer_logo_1.png" alt="Customer Logo 1" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_2.png" alt="Customer Logo 2" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_3.png" alt="Customer Logo 3" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_4.png" alt="Customer Logo 4" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_5.png" alt="Customer Logo 5" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_6.png" alt="Customer Logo 6" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_7.png" alt="Customer Logo 7" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_8.png" alt="Customer Logo 8" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_9.png" alt="Customer Logo 9" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_10.png" alt="Customer Logo 10" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_11.png" alt="Customer Logo 11" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_12.png" alt="Customer Logo 12" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_13.png" alt="Customer Logo 13" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_14.png" alt="Customer Logo 14" />
              </div>
              {/* Duplicate logos for seamless loop */}
              <div className="logo-item">
                <img src="/images/customer/customer_logo_1.png" alt="Customer Logo 1" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_2.png" alt="Customer Logo 2" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_3.png" alt="Customer Logo 3" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_4.png" alt="Customer Logo 4" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_5.png" alt="Customer Logo 5" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_6.png" alt="Customer Logo 6" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_7.png" alt="Customer Logo 7" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_8.png" alt="Customer Logo 8" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_9.png" alt="Customer Logo 9" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_10.png" alt="Customer Logo 10" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_11.png" alt="Customer Logo 11" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_12.png" alt="Customer Logo 12" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_13.png" alt="Customer Logo 13" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_14.png" alt="Customer Logo 14" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="corporate-services-overview">
        <div className="container">
          <div className="section-header">
            <h2>Comprehensive Corporate Travel Services</h2>
            <p>From intimate team meetings to large-scale conferences, we handle every detail of your business travel needs</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🏢</div>
              <h3>Company Offsites</h3>
              <p>Team building retreats, strategic planning sessions, and corporate getaways designed to boost productivity and morale</p>
              <ul>
                <li>Leadership retreats</li>
                <li>Team building activities</li>
                <li>Strategic planning venues</li>
                <li>Executive conferences</li>
              </ul>
              <button 
                className="btn-secondary"
                onClick={() => handleEnquiry('CompanyOffsite', true)}
              >
                Get Quote
              </button>
            </div>
            
            <div className="service-card">
              <div className="service-icon">🎓</div>
              <h3>Educational Tours</h3>
              <p>Safe, educational, and memorable trips for schools, colleges, and educational institutions. Give your children the experience of a lifetime</p>
              <ul>
                <li>School excursions</li>
                <li>College tours</li>
                <li>Educational workshops</li>
                <li>Cultural immersion programs</li>
              </ul>
              <button 
                className="btn-secondary"
                onClick={() => handleEnquiry('Educational Tour', true)}
              >
                Get Quote
              </button>
            </div>
            
            <div className="service-card">
              <div className="service-icon">✈️</div>
              <h3>Corporate Bookings</h3>
              <p>Streamlined booking services for flights, hotels, and ground transportation with corporate rates</p>
              <ul>
                <li>Flight reservations</li>
                <li>Hotel accommodations</li>
                <li>Ground transportation</li>
                <li>Visa assistance</li>
              </ul>
              <button 
                className="btn-secondary"
                onClick={() => handleEnquiry('Corporate Travel Booking Service', true)}
              >
                Get Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="corporate-why-choose">
        <div className="container">
          <div className="row">
            <div className="col-left">
              <h2>Why Organizations Trust Kalyan Travels</h2>
              <p>With over 25 years of experience in the travel industry, we understand the unique requirements of corporate and group travel.</p>
              
              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon">🎯</div>
                  <div className="feature-content">
                    <h4>Dedicated Account Management</h4>
                    <p>Personal account managers who understand your organization's specific needs and preferences</p>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">💰</div>
                  <div className="feature-content">
                    <h4>Corporate Pricing</h4>
                    <p>Negotiated rates with airlines, hotels, and vendors ensuring cost-effective travel solutions</p>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">📋</div>
                  <div className="feature-content">
                    <h4>Detailed Reporting</h4>
                    <p>Comprehensive travel reports and expense tracking for better budget management</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-right">
              <div className="corporate-slideshow">
                <div className="slideshow-container">
                  {destinationImages.map((image, index) => (
                    <div 
                      key={index}
                      className={`slide ${index === currentImageIndex ? 'active' : ''}`}
                    >
                      <img src={image} alt={`Rajasthan Destination ${index + 1}`} />
                    </div>
                  ))}
                </div>
                <div className="slideshow-indicators">
                  {destinationImages.map((_, index) => (
                    <button
                      key={index}
                      className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => setCurrentImageIndex(index)}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CorporateTravel;